import * as _ from 'lodash'
import { EventEmitter, EventSubscription } from 'fbemitter'

// An atom produces an event whenever it changes. That's not configurable. Add a
// listener with onChange. But you can define special batchings, which each have
// their own change event (at the end of the batch).

export class Atom<T> {
  private value: T
  private changeEmitter = new EventEmitter()
  private batchings = {} as {[batchingName: string]: {
    changeEmitter: EventEmitter,
    levels: number,
    changed: boolean,
  }}
  
  constructor(value: T) {
    this.value = value
  }

  get() {
    return this.value
  }

  set(newValue: T) {
    this.value = newValue
    this.reportChange()
  }

  update(func: (oldValue: T) => T) {
    this.value = func(this.value)
    this.reportChange()
  }

  reportChange() {
    this.changeEmitter.emit('change', this.value)
    _.forEach(this.batchings, (batching) => {
      if (batching.levels > 0) {
        batching.changed = true
      } else {
        batching.changeEmitter.emit('change', this.value)
      }
    })
  }

  batch<U>(batchingName: string, func: () => U): U {
    const batching = this.getBatching(batchingName)
    
    if (batching.levels === 0) {
      batching.changed = false
    }

    batching.levels++
    const result = func()
    batching.levels--

    if (batching.levels === 0 && batching.changed) {
      batching.changeEmitter.emit('change', this.value)
    }
    return result
  }

  onChange(func: (value: T) => void): EventSubscription {
    return this.changeEmitter.addListener('change', func)
  }

  onBatchedChange(batchingName: string, func: (value: T) => void): EventSubscription {
    const batching = this.getBatching(batchingName)
    return batching.changeEmitter.addListener('change', func)
  }

  private getBatching(batchingName: string) {
    if (!this.batchings[batchingName]) {
      this.batchings[batchingName] = {
        changeEmitter: new EventEmitter(),
        levels: 0,
        changed: false,
      }
    }

    return this.batchings[batchingName]
  }
}



// WEBPACK FOOTER //
// ./src/lib/Atom.ts